import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CompareProvider } from "@/context/CompareContext";

// Pages
import HomePage from "@/pages/HomePage";
import InventoryPage from "@/pages/InventoryPage";
import EngineDetailPage from "@/pages/EngineDetailPage";
import ComparePage from "@/pages/ComparePage";
import ContactPage from "@/pages/ContactPage";
import SellEquipmentPage from "@/pages/SellEquipmentPage";
import CheckoutPage from "@/pages/CheckoutPage";
import TrackOrderPage from "@/pages/TrackOrderPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminInventoryPage from "@/pages/admin/AdminInventoryPage";
import AdminBrandsPage from "@/pages/admin/AdminBrandsPage";
import AdminQuotesPage from "@/pages/admin/AdminQuotesPage";
import AdminUsersPage from "@/pages/admin/AdminUsersPage";
import AdminNewsletterPage from "@/pages/admin/AdminNewsletterPage";
import AdminSettingsPage from "@/pages/admin/AdminSettingsPage";
import AdminOrdersPage from "@/pages/admin/AdminOrdersPage";

// About Pages
import ProcessesPage from "@/pages/about/ProcessesPage";
import TeamPage from "@/pages/about/TeamPage";
import PurposePage from "@/pages/about/PurposePage";

// Layout
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AdminLayout from "@/components/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import QuickQuoteButton from "@/components/QuickQuoteButton";

function App() {
  return (
    <AuthProvider>
      <CompareProvider>
        <BrowserRouter>
          <div className="App min-h-screen flex flex-col bg-slate-50">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<><Navbar /><HomePage /><Footer /><QuickQuoteButton /></>} />
              <Route path="/inventory" element={<><Navbar /><InventoryPage /><Footer /><QuickQuoteButton /></>} />
              <Route path="/engine/:id" element={<><Navbar /><EngineDetailPage /><Footer /><QuickQuoteButton /></>} />
              <Route path="/compare" element={<><Navbar /><ComparePage /><Footer /><QuickQuoteButton /></>} />
              <Route path="/contact" element={<><Navbar /><ContactPage /><Footer /></>} />
              <Route path="/sell-equipment" element={<><Navbar /><SellEquipmentPage /><Footer /><QuickQuoteButton /></>} />
              <Route path="/checkout/:engineId" element={<><Navbar /><CheckoutPage /><Footer /></>} />
              <Route path="/track" element={<><Navbar /><TrackOrderPage /><Footer /><QuickQuoteButton /></>} />
              
              {/* About Pages */}
              <Route path="/about/processes" element={<><Navbar /><ProcessesPage /><Footer /><QuickQuoteButton /></>} />
              <Route path="/about/team" element={<><Navbar /><TeamPage /><Footer /><QuickQuoteButton /></>} />
              <Route path="/about/purpose" element={<><Navbar /><PurposePage /><Footer /><QuickQuoteButton /></>} />
              
              <Route path="/admin/login" element={<AdminLoginPage />} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
                <Route index element={<AdminDashboard />} />
                <Route path="inventory" element={<AdminInventoryPage />} />
                <Route path="brands" element={<AdminBrandsPage />} />
                <Route path="orders" element={<AdminOrdersPage />} />
                <Route path="quotes" element={<AdminQuotesPage />} />
                <Route path="users" element={<AdminUsersPage />} />
                <Route path="newsletter" element={<AdminNewsletterPage />} />
                <Route path="settings" element={<AdminSettingsPage />} />
              </Route>
            </Routes>
          </div>
          <Toaster position="top-right" />
        </BrowserRouter>
      </CompareProvider>
    </AuthProvider>
  );
}

export default App;
